/**
 * Ordering comparators — jobs are ordered by delivery deadline and
 * administrator priority (PRD acceptance criterion), both in the web
 * dashboard and the driver PWA.
 */
import { PRIORITY_RANK } from './constants.js';
function deadlineTime(job) {
    const iso = job.deadlineAt ?? job.timeWindowStart;
    if (!iso)
        return Number.POSITIVE_INFINITY;
    const t = Date.parse(iso);
    return Number.isNaN(t) ? Number.POSITIVE_INFINITY : t;
}
/** Admin dashboard default: earliest deadline first, then priority (urgent first). */
export function byDeadlineThenPriority(a, b) {
    const d = deadlineTime(a) - deadlineTime(b);
    if (d !== 0)
        return d;
    const p = PRIORITY_RANK[a.priority] - PRIORITY_RANK[b.priority];
    if (p !== 0)
        return p;
    return a.id.localeCompare(b.id);
}
/** Driver PWA default: admin priority first, then earliest deadline. */
export function byPriorityThenDeadline(a, b) {
    const p = PRIORITY_RANK[a.priority] - PRIORITY_RANK[b.priority];
    if (p !== 0)
        return p;
    const d = deadlineTime(a) - deadlineTime(b);
    if (d !== 0)
        return d;
    return a.id.localeCompare(b.id);
}
/** Stable sort helpers (do not mutate the input array). */
export function sortJobsByDeadline(jobs) {
    return [...jobs].sort(byDeadlineThenPriority);
}
export function sortJobsForDriver(jobs) {
    return [...jobs].sort(byPriorityThenDeadline);
}
//# sourceMappingURL=sort.js.map